import React from 'react';
import './HubClearButton.scss';

type HubClearButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  title?: string;
  className?: string;
  'data-testid'?: string;
};

export function HubClearButton({
  onClick,
  disabled = false,
  title = 'Clear',
  className,
  'data-testid': testId,
}: HubClearButtonProps) {
  return (
    <button
      type="button"
      className={`hub-clear-btn${className ? ` ${className}` : ''}`}
      onClick={onClick}
      disabled={disabled}
      title={title}
      data-testid={testId}
    >
      &times;
    </button>
  );
}
